/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_ShareInputs */



/**
* | output |
* | --- |
* | "Share" |
*
* @param {Tournament_ShareInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_share = /** @type {((inputs?: Tournament_ShareInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_ShareInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Partager")
	if (locale === "es") return /** @type {LocalizedString} */ ("Compartir")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Compartilhar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Condividi")
	return /** @type {LocalizedString} */ ("Share")
});